import memoize from 'memoize-one';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import messages from './simulatedContentMapMessages';

function toArray(object) {
  return Array.isArray(object) ? object : [object];
}

export const getClassesOptions = (data = {}) =>
  Object.keys(data)
    .map(key => data[key])
    .map(d => ({ label: d.name, value: d.id }));

export const getCurricularOptions = (data = {}) =>
  Object.keys(data)
    .map(key => data[key])
    .map(d => ({ label: d.cc_name, value: d.cc_id }));

export const getUnitsOptions = (data = {}) =>
  Object.keys(data)
    .map(key => data[key])
    .map(d => ({ label: d.name, value: d.id }));

export const getContentOptions = (data = [], page) => {
  if (!data) return [];
  const result = Object.keys(data)
    .map(key => data[key])
    .map(d => ({ label: `${d.collection} - ${d.name}`, value: d.id }));
  return result;
};

export const getKeywordOptions = (data = []) => data.map(d => ({ label: d.name, value: d.id }));

export const getKeywordGroupedOptions = (data = [], intl, page) => {
  if (!data) return [];
  const result = [];
  const anotherOptions = Object.keys(data)
    .filter(key => !isNaN(key))
    .map(key => ({
      value: data[key].id,
      label: data[key].name,
      related: false,
    }));
  const relatedOptions = data.contents[0].contentAbilities.map(ca => ({
    value: ca.id,
    label: ca.name,
    related: true,
  }));
  if (anotherOptions.length) {
    result.push({
      label: intl.formatMessage(messages.otherAbilities),
      options: anotherOptions,
    });
  }
  if (!relatedOptions.length) {
    return anotherOptions;
  }
  if (data.contents) {
    result.unshift({
      label: intl.formatMessage(messages.abilitiesRelatedToContent),
      options: relatedOptions,
      related: true,
    });
  }
  return result;
};

export const getStatusOptions = (abilities = [], intl) =>
  sortBy(
    uniqBy(abilities, d => d.status),
    'status',
  ).map(d => ({
    label: intl.formatMessage(messages[`status_${d.status}`] || messages.status_fallback),
    value: d.status,
  }));

export const filterAbilities = memoize((abilities, filter) => {
  if (!Object.keys(filter).length) return abilities;
  if (Object.values(filter).every(v => ['', undefined, null].includes(v))) return abilities;
  return abilities.filter(ability => {
    const matchDiscipline = toArray(ability.catalogingDiscipline).some(
      c => !filter.curricular || c.cc_id === filter.curricular,
    );
    const matchUnit = toArray(ability.catalogingMatrix).some(
      c => !filter.unit || c.cc_id === filter.unit,
    );
    const matchLevel = toArray(ability.catalogingLevel).some(
      c => !filter.class || c.id === filter.class,
    );
    const matchStatus =
      filter.status === undefined || Number(ability.status) === Number(filter.status);
    return matchLevel && matchUnit && matchDiscipline && matchStatus;
  });
});

export const getEvaluation = data => {
  const titles = data.evaluation.catalogings.map(c => c.name);
  switch (titles.length) {
    case 0:
      return data;
    case 1:
      return { ...data, title: titles[0] };
    default:
      const lastCataloging = titles[titles.length - 1];
      const catalogingsArray = titles.slice(0, titles.length - 1).join(', ');
      const title = catalogingsArray.concat(` e ${lastCataloging}`);
      return { ...data, title };
  }
};
